import React from 'react';
import PropTypes from 'prop-types';

function ApplePayCardIcon({ className }) {
  return (
    <svg width="34" height="24" viewBox="0 0 34 24" className={className}>
      <g fill="none">
        <rect width="33" height="23" x=".5" y=".5" stroke="#000" rx="3" />
        <g fill="#000">
          <path
            d="M4.749 1.36c.29-.363.487-.85.435-1.349-.425.021-.943.28-1.243.644-.27.311-.509.82-.446 1.296.477.042.953-.238 1.254-.59M5.179 2.045c-.693-.042-1.282.393-1.613.393-.33 0-.837-.373-1.385-.363-.713.01-1.375.414-1.737 1.055C-.3 4.413.248 6.316.972 7.361c.351.517.775 1.086 1.333 1.066.527-.02.734-.342 1.375-.342.64 0 .827.342 1.385.331.58-.01.941-.517 1.293-1.034.403-.59.568-1.158.578-1.19-.01-.01-1.116-.434-1.126-1.706-.01-1.066.868-1.572.91-1.604-.497-.734-1.272-.817-1.541-.837"
            transform="translate(-453 -938) translate(118 874) translate(0 52) translate(335 12) translate(4 6) translate(.506 .94)"
          />
          <path
            d="M3.018.193c1.505 0 2.554 1.038 2.554 2.55 0 1.516-1.07 2.559-2.592 2.559H1.313v2.65H.109V.194h2.909zM1.313 4.291h1.382c1.049 0 1.645-.565 1.645-1.543 0-.98-.596-1.538-1.64-1.538H1.313v3.08zM5.886 6.345c0-.99.759-1.597 2.103-1.672l1.549-.092v-.435c0-.63-.425-1.006-1.135-1.006-.672 0-1.092.323-1.194.828H6.112c.065-1.022.936-1.774 2.334-1.774 1.371 0 2.248.726 2.248 1.86v3.899H9.58v-.93h-.027C9.226 7.652 8.51 8.05 7.769 8.05c-1.108 0-1.883-.689-1.883-1.705zm3.652-.51v-.447l-1.393.086c-.694.048-1.086.355-1.086.839 0 .494.408.817 1.032.817.812 0 1.447-.56 1.447-1.296zM11.745 10.034v-.941c.086.021.28.021.376.021.538 0 .828-.226 1.005-.806 0-.011.103-.344.103-.35l-2.044-5.662h1.259l1.43 4.603h.021l1.431-4.603h1.226l-2.119 5.953c-.484 1.37-1.043 1.812-2.215 1.812-.097 0-.387-.011-.473-.027z"
            transform="translate(-453 -938) translate(118 874) translate(0 52) translate(335 12) translate(4 6) translate(.506 .94) translate(8.193 .41)"
          />
        </g>
      </g>
    </svg>
  );
}

ApplePayCardIcon.propTypes = {
  className: PropTypes.string,
};

module.exports = ApplePayCardIcon;
